<template>
  <div class="home">
    <div class="home-text">
      <p class="list-header" style="font-weight: bold">温馨提示</p>
      <p>
        尊敬的“{{ userObj.userName
        }}{{
          userObj.sex == "男" ? "先生" : "女士"
        }}”，您正在使用第三方支付工具【支付宝】进行您所在莘宇聚鑫官网服务平台账户的充值或相关订单的付款业务，为后续帮您顺利的完成支付，请您再次核对以下信息！
      </p>
      <p style="color: blue; font-weight: bold">莘宇聚鑫平台账户基本信息</p>
      <p>
        您的姓名：<span>{{ userObj.userName }}</span>
      </p>
      <p>
        平台ID号：<span>{{ userObj.membershipId }}</span>
      </p>
      <p>
        绑定手机：<span>{{ userObj.phone }}</span>
      </p>
      <p>您即将进行的付款金额【您也可自定义输入】</p>
      <div class="list-input">
        <el-input
          style="padding: 0 10px"
          v-model="price"
          placeholder="用户充值金额"
          clearable
          @input="inputStop"
          oninput="value=value.replace(/[^0-9.]/g,'')"
          type="Num"
        >
          <el-button slot="append" :disabled="true">元</el-button>
        </el-input>

        <div class="button-title" @click="affirmStop">确认充值</div>
      </div>

      <p class="list-header" style="margin-top: 10px; font-weight: bold">
        重要提示:
      </p>
      <p>
        1.尊敬的平台会员，您正在使用支付宝进行订单的付款或充值业务，使用支付宝付款的话平台需要代为收取一定比例的手续费，请您理解!
      </p>
      <p>2.平台对于使用银行转账的方式进行充值或订单的付款业务免收手续费!</p>
      <p>
        3.您当前使用支付宝充值或支付订单的实际扣款金额=您自定义设置的充值【或付款】金额+手续费
      </p>
      <p class="list-p">
        即: {{ rateObj.wxtotalPrice }} = {{ price == "" ? 0 : price }} +
        {{ price == "" ? 0 : price }} x {{ rateObj.AliRatio }}‰
      </p>
    </div>
  </div>
</template>

<script>
import { loginAffirm, getsettingrechargePay, postZfb } from "../api/index";

export default {
  data() {
    return {
      phone: "",
      price: 0,
      userObj: {},
      //-----
      homeShow: true,
      loading: true,
      //-------
      rateObj: {},
    };
  },
  created() {
    console.log("this.$route.query.price");

    if (this.$route.query.phone) {
      this.phone = this.$route.query.phone;
    }

    if (this.$route.query.price) {
      this.price = this.$route.query.price;
    }

    this.appletMet();
    this.rateMet();
  },
  methods: {
    appletMet() {
      let params = {
        number: this.phone,
      };

      loginAffirm(params).then((res) => {
        if (res.errorCode == null) {
          this.userObj = res.resultData;
        }
      });
    },
    rateMet() {
      let params = {};

      getsettingrechargePay(params).then((res) => {
        if (res.errorCode == null) {
          // res.resultData.AliRatio = Number(res.resultData.AliRatio) / 10;
          let num = this.price * res.resultData.AliRatio;
          let price = Number(this.price) + Number(num / 1000);
          res.resultData.wxtotalPrice = price.toFixed(2);
          this.rateObj = res.resultData;
        }
      });
    },
    cencalStop() {
      this.$router.back(0);
    },
    affirmStop() {
      if (this.price == "") {
        this.$message.warning("充值金额不得为空！");

        return;
      }

      let str = this.price * 100;

      let params = {
        userId: this.userObj.userId,
        price: str,
      };

      postZfb(params).then((res) => {
        if (res.errorCode == null) {
          const div = document.createElement("div");
          div.id = "alipay";
          div.innerHTML = res.resultData;
          document.body.appendChild(div);
          document.querySelector("#alipay").children[0].submit(); // 执行后会唤起支付宝
        }
      });
    },
    inputStop(e) {
      if (e == 0) {
        this.price = "";
        this.rateObj.wxtotalPrice = 0;
      } else {
        console.log("11", this.rateObj.AliRatio / 100);

        let num = Number(e) * Number(this.rateObj.AliRatio);
        console.log("金额诚意百分比", num);
        let price = Number(e) + Number(num / 100);
        console.log("输入金额", price);

        this.rateObj.wxtotalPrice = price.toFixed(2);
      }
    },
    paymentSuccessStop() {},
  },
};
</script>


<style lang="less" scoped>
.home {
  .list-header {
    padding: 0 10px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    height: 40px;
    width: 100%;
    background: #e0eeff;

    .header-img {
      width: 16px;
      height: 16px;
    }

    .header-title {
      font-size: 13px;
      font-weight: bold;
      margin-left: 10px;
    }
  }

  .list-input {
    display: flex;

    /deep/ .el-input-group {
      width: 63%;
      height: 32px;
    }

    /deep/ .el-input__inner {
      height: 32px;
      line-height: 32px;
    }

    .button-title {
      width: 100px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      border-radius: 5px;
      font-weight: bold;
      background: #2a82e2;
      color: #fff;
    }
  }

  .home-text {
    p {
      text-align: left;
      font-size: 13px;
      font-weight: 500;
      color: #050505;
      line-height: 25px;
      margin-top: 0px;
      margin-bottom: 5px;
      padding: 0 10px;
    }

    span {
      font-weight: bold;
    }

    .list-p {
      margin-bottom: 40px;
    }
  }
  .home-button {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    margin-bottom: 20px;

    .button {
      width: 100px;
      height: 32px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 13px;
      border-radius: 5px;
      font-weight: bold;
      border: 1px solid #ccc;
    }

    .button:last-child {
      margin-left: 50px;
      background: #2a82e2;
      color: #fff;
    }
  }
}
</style>